import { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";

export const GoogleAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t, lang } = useT();
  const processedRef = useRef(false);
  const [error, setError] = useState("");
  const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;
    const exchange = async () => {
      try {
        const { data } = await api.post("/auth/google/session", {
          session_id: sessionId,
          ref: localStorage.getItem("deuro_ref") || "",
          lang,
        });
        if (data.is_new) localStorage.removeItem("deuro_onboarded");
        else localStorage.setItem("deuro_onboarded", "1");
        localStorage.removeItem("deuro_ref");
        setUser(data.user);
        navigate("/", { replace: true });
      } catch (err) {
        setUser(null);
        setError(formatApiErrorDetail(err.response?.data?.detail) || t("google_auth_error"));
      }
    };
    if (sessionId) exchange();
    else setError(t("google_auth_error"));
  }, [lang, navigate, sessionId, setUser, t]);

  if (error) {
    return (
      <main className="min-h-screen bg-[#fdfbf7] px-6 flex items-center justify-center">
        <div className="max-w-md text-center" data-testid="google-auth-error">
          <h1 className="font-head text-3xl font-bold">{t("google_auth_error_title")}</h1>
          <p className="mt-3 text-[#5f6b62]">{error}</p>
          <button onClick={() => navigate("/accedi", { replace: true })} data-testid="google-auth-back"
            className="mt-6 rounded-xl bg-[#1e3326] px-5 py-3 font-semibold text-white hover:bg-[#284635]">
            {t("back_to_login")}
          </button>
        </div>
      </main>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fdfbf7]" data-testid="google-auth-processing">
      <Loader2 className="w-8 h-8 animate-spin text-[#d97706]" aria-label={t("google_auth_processing")} />
    </div>
  );
};